import { render, staticRenderFns } from "./RegistrationCard.vue?vue&type=template&id=28b95556&scoped=true&lang=pug&"
import script from "./RegistrationCard.vue?vue&type=script&lang=js&"
export * from "./RegistrationCard.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCard.vue?vue&type=style&index=0&id=28b95556&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b95556",
  null
  
)

export default component.exports